"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6826],{

/***/ 6826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CosmoBox": function() { return /* binding */ CosmoBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41414);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var brand = String("tk").toUpperCase();
var CosmoBoxMenuComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4023), __webpack_require__.e(5089), __webpack_require__.e(4991), __webpack_require__.e(4511), __webpack_require__.e(3458), __webpack_require__.e(5042), __webpack_require__.e(2311), __webpack_require__.e(3853), __webpack_require__.e(5363), __webpack_require__.e(858), __webpack_require__.e(1227)]).then(__webpack_require__.bind(__webpack_require__, 78458)).then(function(m) {
        return m.CosmoBoxMenu;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78458)
            ];
        }
    },
    ssr: false
});
var CosmoBox = function() {
    return /(development|foundation-staging|qa)/i.test(String("foundation-production")) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CosmoBoxMenuComponent, {
        brand: brand,
        country: "US",
        useExistingUnionResources: true
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};


/***/ })

}]);